




import {Vue, Component} from 'vue-property-decorator'

import Payments  from '@/components/Payments.vue'

@Component({
  components: {
      Payments
  }
})
export default class PaymentsView extends Vue {
}
